import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import MainContainer from "../../layout/MainContainer";
import { DocumentViewer } from "../../components";

import {
  useLazyGetTeachingDetailsByIdQuery,
  useLazyGetTutorDetailsQuery,
  useLazyGetnextTutorByIdQuery,
  useLazyGetutorByIdQuery,
} from "../../services/tutor";
import { EmbedPDF } from "@simplepdf/react-embed-pdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ImageIcon from "@mui/icons-material/Image";

import Loader from "../../helpers/Loader";
import { TutorDetails } from "../../types/General";
import { useLazyGetDocucmentsDetailsQuery } from "../../services/documentation";
import moment from "moment";
import { errorToast } from "../../helpers";

import { useLazyGetClassByIdQuery } from "../../services/class";
import Bookings from "../../features/classes/Bookings";
import { gradeCategories } from "../../helpers/constants/enums";
import { classOptions } from "./add";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ClassesDetails = () => {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [img, setImg] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = React.useState(0);
  const { _id } = useParams();
  const [getClassById] = useLazyGetClassByIdQuery();
  const [classDetails, setClassDetails] = useState<any>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const getClass = async (id: string) => {
    try {
      const response = await getClassById({
        classId: id,
      }).unwrap();
      if (response.statusCode === 200) {
        setClassDetails(response?.data);
      }
    } catch (error: any) {
      navigate("/manage-classes");
    }
  };

  const formatDate = (dateString: string) => {
    return moment(dateString).format("DD-MM-YYYY, hh:mm A");
  };

  const getClassMode = (mode: number) => {
    switch (mode) {
      case 1:
        return "Online";
      case 2:
        return "Offline";
      default:
        return "Unknown";
    }
  };

  const getLanguage = (lang: number) => {
    switch (lang) {
      case 1:
        return "English";
      case 2:
        return "Arabic";
      default:
        return "English, Arabic";
    }
  };

  // Add these helper functions at the top of the component
  const getClassType = (type: number) => {
    switch (type) {
      case 1:
        return "Normal";
      case 2:
        return "Recurring";
      default:
        return "Unknown";
    }
  };

  const getPaymentType = (type: number) => {
    switch (type) {
      case 1:
        return "Per Session";
      case 2:
        return "Per Hour";
      default:
        return "Unknown";
    }
  };

  const getRecurrenceType = (type: number) => {
    switch (type) {
      case 1:
        return "Daily";
      case 2:
        return "Weekly";
      case 3:
        return "Monthly";
      default:
        return "None";
    }
  };

  useEffect(() => {
    if (_id) {
      getClass(_id);
    }
  }, [_id]);

  if (!classDetails) {
    return <Loader isLoad={true} />;
  }

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">View Class Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate(-1);
              // navigate(state?.backRoute ? -1 : "/manage-classes");
            }}
          >
            Back
          </Button>
        </div>

        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Class details" {...a11yProps(0)} />
                <Tab label="Bookings" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </Box>
          <CardContent sx={{ p: 1, mt: 3 }}>
            <CustomTabPanel value={value} index={0}>
              <Grid container spacing={2} className="view_box">
                <Grid item xs={12}>
                  <Typography component="h5">Class Thumbnail</Typography>
                  <figure
                    className="profile_img"
                    onClick={() => {
                      setOpen(true);
                      setImg(classDetails?.thumbnail);
                    }}
                  >
                    <img
                      style={{
                        height: 100,
                        width: 250,
                        borderRadius: 0,
                      }}
                      src={
                        classDetails?.thumbnail ||
                        `/static/images/user_placeholder.png`
                      }
                      alt="Class Thumbnail"
                    />
                  </figure>
                </Grid>

                {classDetails?.teaser && (
                  <Grid item xs={12}>
                    <Typography component="h5">Class Teaser Video</Typography>
                    {/* <figure> */}
                    <video
                      style={{
                        height: 100,
                        width: 250,
                        borderRadius: 0,
                      }}
                      controls
                      muted
                      autoPlay
                      src={classDetails?.teaser}
                    />
                    {/* </figure> */}
                  </Grid>
                )}

                <Grid item xs={10} className="view_box_list">
                  <Grid container spacing={3}>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Tutor</Typography>
                        <Typography component="p">
                          {classDetails?.tutor?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    {classDetails?.coTutor?.name && (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Co-Tutor</Typography>
                          <Typography component="p">
                            {classDetails?.coTutor?.name}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Subject</Typography>
                        <Typography component="p">
                          {classDetails?.subjects?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Topic</Typography>
                        <Typography component="p">
                          {classDetails?.topic || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    {/* View Mode - Display Grades as Read-Only */}
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Grade Options
                      </Typography>
                      {/* <Typography variant="p" > */}
                      {classDetails?.grades?.length > 0 ? (
                        classDetails?.grades?.map((value: any, index: any) => {
                          const gradeOption = classOptions?.find(
                            (opt: any) => opt.value === String(value)
                          );
                          return index === 0
                            ? gradeOption?.label
                            : ", " + gradeOption?.label;
                        })
                      ) : (
                        <Typography color="textSecondary">
                          No grades selected
                        </Typography>
                      )}
                      {/* </Typography> */}
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Fees</Typography>
                        <Typography component="p">
                          {classDetails?.fees || "0"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Seats</Typography>
                        <Typography component="p">
                          {classDetails?.seats || "0"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Language</Typography>
                        <Typography component="p">
                          {getLanguage(classDetails?.language)}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Class Mode</Typography>
                        <Typography component="p">
                          {getClassMode(classDetails?.classMode)}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Availability</Typography>
                        <Typography component="p">
                          {classDetails?.canBePrivate ? "Private" : "Public"}s
                        </Typography>
                      </Box>
                    </Grid>

                    {/* Add these new fields */}
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Class Type</Typography>
                        <Typography component="p">
                          {getClassType(classDetails?.classType)}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Payment Type</Typography>
                        <Typography component="p">
                          {getPaymentType(classDetails?.payment)}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Free Lesson</Typography>
                        <Typography component="p">
                          {classDetails?.isFreeLesson ? "Yes" : "No"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">
                          Duration (minutes)
                        </Typography>
                        <Typography component="p">
                          {classDetails?.duration || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    {(classDetails?.classMode === 1 ||
                      classDetails?.classMode === 3) && (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Address</Typography>
                          <Typography component="p">
                            {classDetails?.address || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.promoCodes?.length > 0 && (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Promo Codes</Typography>
                          {classDetails.promoCodes.map((code: any) => (
                            <Typography key={code._id} component="p">
                              {code.name} ({code.codeName})
                            </Typography>
                          ))}
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.classType === 2 && (
                      <>
                        <Grid item lg={4} md={4} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              Recurrence Type
                            </Typography>
                            <Typography component="p">
                              {getRecurrenceType(classDetails?.recurrenceType)}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={4} md={4} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">Repeat Every</Typography>
                            <Typography component="p">
                              {classDetails?.repeatEvery || "-"} weeks
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={4} md={4} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">Continue For</Typography>
                            <Typography component="p">
                              {classDetails?.continueFor || "-"} weeks
                            </Typography>
                          </Box>
                        </Grid>
                      </>
                    )}

                    {/* {classDetails?.promoCodeId && (
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Promo Code</Typography>
                        <Typography component="p">
                          {classDetails?.promoCodeId}
                        </Typography>
                      </Box>
                    </Grid>
                  )} */}

                    {classDetails?.searchTags?.length > 0 && (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Search Tags</Typography>
                          <Typography component="p">
                            {classDetails?.searchTags.join(", ")}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.description && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Description</Typography>
                          <Typography component="p">
                            {classDetails?.description || ""}
                          </Typography>
                          {/* <Typography
                            component="div"
                            dangerouslySetInnerHTML={{
                              __html: classDetails?.description || "",
                            }}
                          /> */}
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.objective && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Objective</Typography>
                          <Typography component="p">
                            {classDetails?.objective}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.allOutcome && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">All Outcomes</Typography>
                          <Typography component="p">
                            {classDetails?.allOutcome}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.mostOutcome && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Most Outcomes</Typography>
                          <Typography component="p">
                            {classDetails?.mostOutcome}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.someOutcome && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Some Outcomes</Typography>
                          <Typography component="p">
                            {classDetails?.someOutcome}
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.notes && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Notes</Typography>
                          <Typography
                            component="div"
                            dangerouslySetInnerHTML={{
                              __html: classDetails?.notes || "",
                            }}
                          />
                        </Box>
                      </Grid>
                    )}

                    {/* {classDetails?.material?.length > 0 && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Materials</Typography>
                          {classDetails?.material.map(
                            (material: string, index: number) => (
                              <div key={index}>
                                <EmbedPDF>
                                  <a
                                    href={material}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Material {index + 1}
                                  </a>
                                </EmbedPDF>
                              </div>
                            )
                          )}
                        </Box>
                      </Grid>
                    )} */}

                    {/* {classDetails?.material?.length > 0 && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5">Materials</Typography>
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
                          >
                            {classDetails.material.map(
                              (material: string, index: number) => (
                                <Box
                                  key={index}
                                  sx={{
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                    p: 1,
                                    width: 200,
                                  }}
                                >
                                  {material.endsWith(".pdf") ? (
                                    <EmbedPDF companyIdentifier="yourcompany">
                                      <a
                                        href={material}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "none" }}
                                      >
                                        <Typography variant="body2">
                                          <FileDownloadIcon sx={{ mr: 1 }} />
                                          Material {index + 1} (PDF)
                                        </Typography>
                                      </a>
                                    </EmbedPDF>
                                  ) : (
                                    <a
                                      href={material}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ textDecoration: "none" }}
                                    >
                                      <Typography variant="body2">
                                        <ImageIcon sx={{ mr: 1 }} />
                                        Material {index + 1}
                                      </Typography>
                                    </a>
                                  )}
                                </Box>
                              )
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    )} */}

                    {classDetails?.material?.length > 0 && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h5" sx={{ mb: 1 }}>
                            Materials
                          </Typography>

                          <Grid container spacing={2} sx={{ pl: 2 }}>
                            {classDetails.material.map(
                              (fileUrl: any, index: any) => {
                                const isPDF = fileUrl
                                  .toLowerCase()
                                  .endsWith(".pdf");
                                return (
                                  <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Box className="upload_pdf_preview">
                                      <>
                                        {isPDF ? (
                                          <EmbedPDF companyIdentifier="yourcompany">
                                            <a
                                              href={fileUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="pdf_uplod"
                                              style={{
                                                textAlign: "center",
                                                display: "block",
                                              }}
                                            >
                                              <img
                                                src="/static/images/pdf.png"
                                                alt="PDF"
                                                style={{
                                                  width: "80px",
                                                  height: "auto",
                                                  marginBottom: 8,
                                                }}
                                              />
                                            </a>
                                          </EmbedPDF>
                                        ) : (
                                          <img
                                            src={fileUrl}
                                            alt={`Material ${index + 1}`}
                                            style={{
                                              width: "100%",
                                              maxHeight: "200px",
                                              objectFit: "contain",
                                              borderRadius: 8,
                                              marginBottom: 8,
                                            }}
                                          />
                                        )}
                                        {/* <Typography
                                          variant="body2"
                                          component="h6"
                                        >
                                          {isPDF
                                            ? "Study Material"
                                            : "Image Material"}
                                        </Typography> */}
                                      </>
                                    </Box>
                                  </Grid>
                                );
                              }
                            )}
                          </Grid>
                        </Box>
                      </Grid>
                    )}

                    {classDetails?.classslots?.length > 0 && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography component="h4" fontWeight={"bold"}>
                            Class Slots
                          </Typography>
                          <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box>
                              <Typography component="h5">Timezone</Typography>
                              <Typography component="p">
                                {classDetails?.classslots[0]?.timezone}
                              </Typography>
                            </Box>
                          </Grid>
                          {classDetails?.classslots.map(
                            (slot: any, index: number) => (
                              <div
                                key={slot._id}
                                style={{ marginBottom: "16px" }}
                              >
                                <Typography component="h6">
                                  Slot {index + 1}
                                </Typography>
                                <Typography component="p">
                                  Date: {formatDate(slot.date).slice(0, 10)}
                                </Typography>
                                <Typography component="p">
                                  Time: {formatDate(slot.startTime).slice(11)} -{" "}
                                  {formatDate(slot.endTime).slice(11)}
                                </Typography>
                                <Typography component="p">
                                  Seats: {slot.seats} (Remaining:{" "}
                                  {slot.remainingSeats})
                                </Typography>
                              </div>
                            )
                          )}
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Bookings />
            </CustomTabPanel>
          </CardContent>
        </Card>
      </div>
      <DocumentViewer open={open} setOpen={setOpen} img={img} />
    </MainContainer>
  );
};

export default ClassesDetails;
